/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2FQfX%7Bpadding-top%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbFQfX%7Bpadding-right%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWFQfX%7Bpadding-bottom%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QFQfX%7Bpadding-left%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02E6Kk%7Bwidth%3A-moz-fit-content%3Bwidth%3Afit-content%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6B7dHp%7Bz-index%3A1%7D");
import AnimatedSvgContainer from './animated-svg-container';
import type { AIGlowingBorderProps } from './types';
const borderContainerStyles = null;
const borderContentStyles = null;

/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */
const AIGlowingBorder = ({
  children,
  palette,
  isMoving = true,
  isGlowing,
  testId,
  className
}: AIGlowingBorderProps): JSX.Element => <div data-testid={testId} className={ax(["_3iDTPbQ4SZ _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _39xV02E6Kk"])}>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop */}
		<AnimatedSvgContainer palette={palette} isMoving={isMoving} className={className} />
		{isGlowing &&
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  <AnimatedSvgContainer palette={palette} isMoving={isMoving} isGlowing className={className} />}
		<div className={ax(["_0bjKvD8fU6 _2O5Vij7dHp _42Yu6B7dHp"])}>{children} </div>
	</div>;
export default AIGlowingBorder;